const SubscribeSecondSvg = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none"><circle cx="25" cy="25" r="24.5" fill="#fff" stroke="#6FE1B8"/>
          <path fill="#546EDB" d="M24.98 12C17.777 12.03 12 17.853 12 24.987c0 2.113.646 4.15 1.626 6.016l-1.584 5.824a.93.93 0 0 0 1.14 1.139l5.823-1.585c1.864.98 3.897 1.619 6.01 1.619 7.177 0 13.021-5.835 13.021-13.013C38.036 17.81 32.19 11.97 24.98 12Zm-5.536 9.268h11.148a.927.927 0 0 1 .926.933.93.93 0 0 1-.926.926H19.444a.929.929 0 0 1 0-1.859Zm.426 5.578h7.97a.931.931 0 0 1 .659 1.59.928.928 0 0 1-.658.269h-7.97a.928.928 0 0 1-.661-1.587.93.93 0 0 1 .66-.272Z"/>
      </svg>
  )
}

export default SubscribeSecondSvg;